import { FormattedMessage } from "react-intl";
import { openSnackbar } from "store/slices/snackbar";

export const getErrorCode = (err) => {
  if (err.response && err.response.data && err.response.data.code) {
    return err.response.data.code;
  }
  return "Exceptions::default";
};

export const openSnackbarWithSuccess = (message, dispatch) => {
  dispatch(
    openSnackbar({
      open: true,
      message: <FormattedMessage id={message} />,
      variant: "alert",
      alert: {
        color: "success",
      },
      close: true,
    })
  );
};

export const openSnackbarWithError = (
  error,
  dispatch,
  isPlainTextError = false
) => {
  console.error(error);

  const errorCode = getErrorCode(error);
  dispatch(
    openSnackbar({
      open: true,
      message: isPlainTextError ? (
        error
      ) : (
        <FormattedMessage id={`errors.${errorCode}`} />
      ),
      variant: "alert",
      alert: {
        color: "error",
      },
      close: false,
    })
  );
};
